import { render, staticRenderFns } from "./contract-renewal.vue?vue&type=template&id=2a8281af&scoped=true"
import script from "./contract-renewal.vue?vue&type=script&lang=js"
export * from "./contract-renewal.vue?vue&type=script&lang=js"
import style0 from "./contract-renewal.vue?vue&type=style&index=0&id=2a8281af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8281af",
  null
  
)

export default component.exports